import { getCSRFToken } from '../lib/django';

const BASE = process.env.REACT_APP_API_BASE ||  "http://127.0.0.1:8000";

export async function listFiles(path = "/") {
  const res = await fetch(`${BASE}/api/files/?path=${encodeURIComponent(path)}`);
  if (!res.ok) throw new Error("Kunde inte hämta filer");
  const data = await res.json();
  return Array.isArray(data.items) ? data.items : [];
}

export async function uploadFile({ path = "/", file, relativePath = "", tags = "" }) {
  const fd = new FormData();
  fd.append("path", path);
  if (relativePath) fd.append("relative_path", relativePath);
  if (tags) fd.append("tags", tags);
  fd.append("file", file);

  const res = await fetch(`${BASE}/api/files/upload/`, {
    method: "POST",
    headers: { "X-CSRFToken": getCSRFToken() },
    body: fd,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Uppladdning misslyckades");
  }
  return res.json();
}

export async function deleteFile(fileId) {
  const res = await fetch(`${BASE}/api/files/${fileId}/`, {
    method: "DELETE",
    headers: { "X-CSRFToken": getCSRFToken() },
  });
  if (!res.ok) throw new Error("Kunde inte ta bort fil");
  return res.json();
}

export async function updateFileTags(fileId, tags = "") {
  const res = await fetch(`${BASE}/api/files/${fileId}/tags/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify({ tags }),
  });
  if (!res.ok) throw new Error("Kunde inte uppdatera tags för fil");
  return res.json();
}

export async function createFolder({ path = "/", name, tags = "" }) {
  const res = await fetch(`${BASE}/api/folders/create/`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify({ path, name, tags }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Kunde inte skapa mapp");
  }
  return res.json();
}

export async function updateFolderTags(folderId, tags = "") {
  const res = await fetch(`${BASE}/api/folders/${folderId}/tags/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify({ tags }),
  });
  if (!res.ok) throw new Error("Kunde inte uppdatera tags för mapp");
  return res.json();
}

export async function deleteFolder(folderId, { force = false } = {}) {
  const url = `${BASE}/api/folders/${folderId}/` + (force ? `?force=1` : "");
  const res = await fetch(url, {
    method: "DELETE",
    headers: { "X-CSRFToken": getCSRFToken() },
  });


  if (res.status === 409) {
    const data = await res.json();
    const msg =
      `Mappen "${data.folder_name}" är inte tom.\n` +
      `Innehåller: ${data.counts.folders} mappar och ${data.counts.files} filer.\n\n` +
      `Vill du radera ALLT?`;

    if (window.confirm(msg)) {
      return await deleteFolder(folderId, { force: true });
    }
    return { ok: false, cancelled: true };
  }

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Kunde inte ta bort mapp");
  }

  return await res.json();
}
